import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal, warningGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';

import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Anounncement listing
export const announcementListing = createAsyncThunk(
    'announcement/announcementListing',
    async({ currentBranch, year }, { dispatch }) => {  // Destrukturalizácia objektu
        try {

            const request = await axios.get(`/api/announcement/announcement-listing`, {
                params: { 
                    branchId: currentBranch,
                    year 
                },
                ...getAuthHeader()
            });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Announcement detail
export const announcementDetail = createAsyncThunk(
    'announcement/announcementDetail',
    async({ currentBranch, year, activityCode }, { dispatch }) => {
        try {

            const request = await axios.get(`/api/announcement/detail`, {
                params: {
                    branchId: currentBranch,
                    year: year,
                    activityCode: activityCode
                },
                ...getAuthHeader()
            });
            return request.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Export to PDF
export const exportAnnouncementToPdf = createAsyncThunk(
    'announcement/announcementExportToPdf',
    async({currentBranch, announcement, year, activityCode, tenantName}, { dispatch }) => {
        try{

            const response = await axios.post(`/api/announcement/generate-announcement-pdf`,
                {
                    branchId: currentBranch,
                    announcementData: announcement,
                    year: year,
                    activityCode: activityCode
                },
                {
                    ...getAuthHeader(),
                    responseType: 'blob',
                }
            );

            dispatch(successGlobal('Ohlásenie odpadov bolo úspšene exportované do PDF'));

            const filename = `Ohlasenie odpadov ${tenantName} ${year}.pdf`;
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.open(url, '_blank');
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
            return { success: true };

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Export announcement to XML
export const exportAnnouncementToXml = createAsyncThunk(
    'announcement/announcementExportToXml',
    async({currentBranch, announcement, year, activityCode, tenantName}, { dispatch }) => {
        try{
            const response = await axios.post(`/api/announcement/generate-announcement-xml`,
                {
                    branchId: currentBranch,
                    announcementData: announcement,
                    year: year,
                    activityCode: activityCode
                },
                {
                    ...getAuthHeader(),
                    responseType: 'blob',
                }
            );

            const skippedMessage = response.headers['x-skipped-message'];
            if (skippedMessage) {
                dispatch(warningGlobal(decodeURIComponent(skippedMessage)));
            } else {
                dispatch(successGlobal('Ohlásenie odpadov bolo úspšene exportované do XML'));
            }

            const url = window.URL.createObjectURL(response.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Ohlasenie odpadov ${tenantName} ${year}.xml`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); 

            window.URL.revokeObjectURL(url);

            return { success: true };

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

export const importAnnouncementData = createAsyncThunk(
    'announcement/importAnnouncementData',
    async (importData, { dispatch }) => {
      try {
         return importData;
      } catch (error) {
        throw error;
      }
    }
  );